import React from "react";
import ReactSlider from "react-slider";

const Renderreponsiveinputrange = (props) => {
  const isVVI = props.instrumentType === "VVI";
  const maxValue = isVVI ? 5 : 10;

  const handleChange = (value) => {
    props.handleInputRange(value);
  };

  const generateLabels = () => {
    const count = isVVI ? 6 : 11;
    return [...Array(count)].map((_, i) => (
      <div key={i} className="label">
        {i}
      </div>
    ));
  };

  return (
    <div className="slider-container">
      <div className="slider-with-labels">
        <div className="number-labels">
          {generateLabels()}
        </div>
        
        <div className="slider-track-container">
          <ReactSlider
            className="vertical-slider"
            thumbClassName="slider-thumb"
            trackClassName="slider-track"
            orientation="vertical"
            value={props.value}
            min={0}
            max={maxValue}
            step={0.1}
            onChange={handleChange}
            renderThumb={(props, state) => (
              <div {...props}>
                <div className="value-display">
                  {state.valueNow.toFixed(1)}
                </div>
              </div>
            )}
          />
        </div>
      </div>

      <style jsx global>{`
        .slider-container {
          padding: 10px 10px;
          background: #f5f5f5;
          border-radius: 8px;
          width: fit-content;
        }

        .slider-with-labels {
          display: flex;
          align-items: center;
          gap: 30px;
          height: 500px; /* Increased height */
        }

        .number-labels {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          height: 100%;
          padding: 12px 0;
        }

        .label {
          font-size: 14px;
          color: #666;
        }

        .slider-track-container {
          height: 100%;
          padding: 10px 0;
          display: flex;
          align-items: center;
          position: relative;
        }

        .vertical-slider {
          height: 100% !important;
          width: 2px;
          touch-action: none;
          background: #e0e0e0;
        }

        .slider-thumb {
          background-color: white;
          border: 2px solid #32c536;
          border-radius: 50%;
          cursor: grab;
          width: 26px;
          height: 26px;
          left: -11px;
          position: absolute;
          z-index: 100;
          outline: none;
        }

        .slider-thumb:active {
          cursor: grabbing;
        }

        .slider-track {
          background: #32c536;
          width: 100%;
        }

        .value-display {
          position: absolute;
          top: -50px;
          left: 50%;
          transform: translateX(-50%);
          background: #32c536;
          color: white;
          padding: 4px 8px;
          border-radius: 4px;
          font-size: 14px;
          font-weight: bold;
          white-space: nowrap;
          z-index: 101;
        }

        /* Add arrow pointing down */
        .value-display::after {
          content: '';
          position: absolute;
          bottom: -7px;
          left: 50%;
          transform: translateX(-50%);
          width: 0;
          height: 0;
          border-left: 6px solid transparent;
          border-right: 6px solid transparent;
          border-top: 6px solid #32c536;
        }
      `}</style>
    </div>
  );
};

export default Renderreponsiveinputrange;


// WEBPACK FOOTER //
// ./src/new/Components/Self-assessment/begin-questionnaire/responsive/responsive-input-range.jsx